import type { IChartBucket, TBand, TBarSeries } from '../../shared/ui/status-bars';
import type { TRunChart } from './api';
import type { TRunShow } from './filters';

export type TRunGroup = 'delivered' | 'failing' | 'stopped' | 'inProgress';

export interface IRunGroup {
  key: TRunGroup;
  legend: string;
  label: string;
  band: TBand;
  /** The status tab that shows exactly this group; delivered has none. */
  show?: TRunShow;
}

export const RUN_GROUPS: readonly IRunGroup[] = [
  { key: 'delivered', legend: 'delivered', label: 'Delivered', band: 'success' },
  { key: 'failing', legend: 'failing', label: 'Failing', band: 'failure', show: 'problems' },
  {
    key: 'stopped',
    legend: 'stopped by a step',
    label: 'Stopped by a step',
    band: 'suppressed',
    show: 'stopped',
  },
  {
    key: 'inProgress',
    legend: 'in progress',
    label: 'In progress',
    band: 'motion',
    show: 'progress',
  },
];

export const RUN_CHART_SERIES: TBarSeries = Object.fromEntries(
  RUN_GROUPS.map((group) => [group.key, { band: group.band, label: group.label }]),
);

export const runChartBuckets = (chart: TRunChart | undefined): IChartBucket[] =>
  (chart?.buckets ?? []).map((bucket) => ({
    start: bucket.start,
    end: bucket.end,
    total: bucket.total,
    byStatus: Object.fromEntries(RUN_GROUPS.map((group) => [group.key, bucket[group.key]])),
  }));
